import type { ChipComponent } from "@app/widgets/base/chip/chip.component";
import type { CbSelectOption } from "@app/widgets/base/select/select.component";

export const PALLET_COLOR_MAP: ReturnType<
	typeof ChipComponent.prototype.colorMap
> = {
	incoming: "info",
	arrived: "pink",
	stored: "gray",
	not_arrived: "error",
	to_go: "warning",
	assigned: "info",
	gone: "gray",
	not_gone: "error",
	ready: "success",
	archived: "gray",
};

export const PALLET_LABEL_MAP: Record<string, string> = {
	incoming: "ORDERS.FILTERS.PALLETS.OPTIONS.INCOMING",
	arrived: "ORDERS.FILTERS.PALLETS.OPTIONS.ARRIVED",
	not_arrived: "ORDERS.FILTERS.PALLETS.OPTIONS.NOT_ARRIVED",
	stored: "ORDERS.FILTERS.PALLETS.OPTIONS.STORED",
	assigned: "ORDERS.FILTERS.PALLETS.OPTIONS.ASSIGNED",
	to_go: "ORDERS.FILTERS.PALLETS.OPTIONS.TO_GO",
	gone: "ORDERS.FILTERS.PALLETS.OPTIONS.GONE",
	not_gone: "ORDERS.FILTERS.PALLETS.OPTIONS.NOT_GONE",
	ready: "ORDERS.FILTERS.PALLETS.OPTIONS.READY",
	archived: "ORDERS.FILTERS.PALLETS.OPTIONS.ARCHIVED",
};

export const PALLET_ALERT_STAGE_MAP: Record<string, string> = {
	incoming_order: "PALLETS.ALERT.INCOMING_ORDER",
	outgoing_order: "PALLETS.ALERT.OUTGOING_ORDER",
	moving_udc: "PALLETS.ALERT.MOVING_UDC",
	backoffice: "PALLETS.ALERT.BACKOFFICE",
	inventory: "PALLETS.ALERT.INVENTORY",
	palmtop: "PALLETS.ALERT.PALMTOP",
};

export const PALLET_STATUS_OPTIONS: CbSelectOption[] = Object.entries(
	PALLET_LABEL_MAP,
).map(([key, value]) => ({
	value: key,
	label: value,
}));

export const PALLET_SELECT_STATUS: string[] = [
	"incoming",
	"arrived",
	"not_arrived",
	"stored",
	// "assigned",
	// "to_go",
	// "not_gone",
	// "gone",
	// "archived",
];

export const PALLET_INVENTORY_STEP_LABEL_MAP: Record<string, string> = {
	scanned: "PALLETS.INVENTORY.STEP.TYPE.SCANNED",
	corrected: "PALLETS.INVENTORY.STEP.TYPE.CORRECTED",
	wrong_products: "PALLETS.INVENTORY.STEP.TYPE.WRONG_PRODUCTS",
	moved: "PALLETS.INVENTORY.STEP.TYPE.MOVE",
	not_scanned: "PALLETS.INVENTORY.STEP.TYPE.NOT_SCANNED",
};
export const PALLET_INVENTORY_STEP_ICON_MAP: Record<string, string> = {
	scanned: "cb-app-bold-bar-code-02",
	corrected: "cb-app-bold-edit",
	moved: "cb-app-bold-move",
	wrong_products: "cb-app-bold-spam",
	not_scanned: "cb-app-bold-eyeoff",
};

export const PALLET_INVENTORY_ANOMALY_MAP: Record<string, string> = {
	not_scanned: "PALLETS.INVENTORY.ANOMALY.NOT_SCANNED",
	wrong_products: "PALLETS.INVENTORY.ANOMALY.WRONG_PRODUCTS",
	corrected: "PALLETS.INVENTORY.ANOMALY.CORRECTED",
	moved: "PALLETS.INVENTORY.ANOMALY.MOVED",
};
export const PALLET_INVENTORY_ANOMALY_COLOR_MAP: Record<
	string,
	"error" | "warning" | "success" | "info"
> = {
	not_scanned: "error",
	wrong_products: "warning",
	corrected: "success",
	moved: "info",
};
export const PALLET_INVENTORY_ANOMALY_ICON_MAP: Record<string, string> = {
	not_scanned: "cb-app-bold-bar-code-02",
	wrong_products: "cb-app-outline-package-remove",
	corrected: "cb-base-outline-edit",
	moved: "cb-app-outline-trolley-01",
};
